import React from "react";
import "./Projects.css";
import { FaNodeJs, FaReact } from "react-icons/fa";
import {
  SiHtml5,
  SiRedux,
  SiChakraui,
  SiExpress,
  SiMongodb
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { IoLogoJavascript } from "react-icons/io";
import monster from "../../Assets/MonsterIndia.png"
import giftcart from "../../Assets/Giftcart.png"
import shop from "../../Assets/SHOP.png"
import { BsBootstrap } from "react-icons/bs";



export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different" data-aos="fade-right">
          Projects
        </h2>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://camo.githubusercontent.com/2e7d95b990d879025a1038c3e10b863c3930cdd3d99d4ddf0cbb8d760e846b99/68747470733a2f2f692e706f7374696d672e63632f5a59644c443473592f686f6d65706167652e706e67"
                  alt="toggleTrack.com"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2> ToggleTrack-clone</h2>
              <p>
              Toggl Track is a time tracking software operated by Toggl, that tracks time blocks, optionally labeled with a task, a project, and tags.
              <br/> 
            
              <span className="features">Features : </span>Landing Page, Login Page,signup page,pricing page,timer page,Book a demo.
              
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
                <FaReact/>
                <SiRedux/>
                <SiChakraui/>
                <SiExpress/>
                <FaNodeJs/>
                <SiMongodb/>
              </div>
              <div className="twobtn">
                <a
                  href="https://toggltracksite.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/mamataingole125/ToggleTrack"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={monster}
                  alt="monster.com"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2> Monsterindia-clone</h2>
              <p>
              Monster.com is a leading online employment solution helping people to find the right
              jobs.<br/> 
            
              <span className="features">Features: </span>Landing Page, Login Page, Signup page, Job Search Page, Profile Page, premium service Page, Career Tips page.
              
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
                <FaReact/>
                <SiRedux/>
                <SiChakraui/>
              </div>
              <div className="twobtn">
                <a
                  href="https://stellular-kleicha-361f06.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/mamataingole125/MonsterIndiaClone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={shop}
                  alt="shop-clone"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2 className="shop">SHOP.COM-clone</h2>
              <p>
              SHOP.COM is a new kind of shopping comparison site that offers the most comprehensive shopping experience on the web.<br/>
              <span className="features">Features: </span>Landing Page, Login Page, Product Pages, Cart Page, Checkout Page
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div className="twobtn">
                <a
                  href="https://shop-com-clone-web17.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/mamataingole125/SHOP.COM-clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src={giftcart}
                  alt="giftcart-clone"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Giftcart-clone </h2>
              <p>
              Giftcart.com is an online gift shopping website.<br/>
               <span className="features">Features: </span>Landing Page, Login Page, Signup page, Product Pages, Cart Page, Checkout Page, FAQ page.
              </p>
              <div>
              <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
                <BsBootstrap/>
              </div>
              <div className="twobtn">
                <a
                  href="https://giftcart-clone.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                  See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/mamataingole125/Gift_Cart"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
   
      </div>
    </>
  );
};